import { Injectable } from "@angular/core";
import { IAuthenticationResult } from "src/app/model/custom/IUserLoginEvent";

@Injectable({
	providedIn: "root",
})
export class AuthV1Service {
	private getData(key) {
		let val = "";

		if (!val) {
			val = localStorage.getItem(key) || "";
			val = val.replace(/"/g, "");
		}
		return val;
	}
	getAuthData() {
		const cognitoDataObj: IAuthenticationResult = {
			IdToken: this.getData("cognito_IdToken"),
			AccessToken: this.getData("cognito_access_token"),
			ExpiresIn: Number(this.getData("cognito_access_token_expires_in")),
			TokenType: this.getData("cognito_access_token_type"),
			RefreshToken: this.getData("cognito_refresh_token"),
		};
		return cognitoDataObj;
	}
	private setData(key, value) {
		let val = "";

		if (!val) {
			localStorage.setItem(key, value);
		}
		return val;
	}
	private removeData(key) {
		let val = "";
		if (!val) {
			localStorage.removeItem(key);
		}
		return val;
	}

	setAuthData(result: IAuthenticationResult) {
		if (!result) {
			return;
		}
		this.setData("cognito_IdToken", `"${result.IdToken}"`);
		this.setData("cognito_access_token", `"${result.AccessToken}"`);
		this.setData("cognito_access_token_expires_in", `"${result.ExpiresIn}"`);
		this.setData("cognito_access_token_type", `"${result.TokenType}"`);
		this.setData("cognito_refresh_token", `"${result.RefreshToken}"`);
	}

	clearAuthData() {
		this.removeData("cognito_IdToken");
		this.removeData("cognito_access_token");
		this.removeData("cognito_access_token_expires_in");
		this.removeData("cognito_access_token_type");
		this.removeData("cognito_refresh_token");
		this.removeData("user");
	}
}
